var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo } from 'react';
import { useFeatureFlagsContext } from '#context';
import { areExperimentalFeaturesEnabled, isEnabledFromFeatureFlag, } from '#services';
/**
 * Function must match the guards in other feature flag functionality
 * see `FeatureFlagGuard` and `FeatureFlag` component
 */
export const useIsEnabledFeatureFlag = () => {
    _react_refresh_temp_1();
    const { isError: isAmplitudeError, isPending, variants, } = useFeatureFlagsContext();
    const isEnabledFeatureFlag = useCallback((featureFlagProperties, ignoreExperimentalFeatures = false) => {
        if (isAmplitudeError && !ignoreExperimentalFeatures) {
            /**
             * Fallback to experimental feature flag
             * to enable local development where
             * there is no Amplitude engaged:
             */
            return areExperimentalFeaturesEnabled();
        }
        return isEnabledFromFeatureFlag({
            ...featureFlagProperties,
            variants,
        });
    }, [isAmplitudeError, variants]);
    return useMemo(() => {
        return {
            isEnabledFeatureFlag,
            isPending,
        };
    }, [isEnabledFeatureFlag, isPending]);
};
_react_refresh_temp_1(useIsEnabledFeatureFlag, "k9CWOfy0ekMsF04Hb3Y9alEjQgo=", false, () => [useFeatureFlagsContext]);
